"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleHighlight = exports.onTrash = exports.onReport = exports.onMarkAsSpam = exports.onEdit = exports.getPermalink = exports.extraMenuItems = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _topicService = require("@insided/shared/services/topicService");

var _topicService2 = require("@insided/destination/modules/Content/TopicList/services/topicService");

var extraMenuItems = function extraMenuItems(params) {
  var showReportContentModal = params.showReportContentModal,
      postId = params.postId,
      onEditClick = params.onEditClick,
      privateReplyId = params.privateReplyId,
      isPostTranslated = params.isPostTranslated,
      onDisplayOriginal = params.onDisplayOriginal,
      showMarkAsSpamModal = params.showMarkAsSpamModal,
      showTrashModal = params.showTrashModal,
      contentType = params.contentType,
      isReplyHighlighted = params.isReplyHighlighted,
      onHighlightReply = params.onHighlightReply,
      onShowAlert = params.onShowAlert,
      isClosed = params.isClosed,
      privateId = params.privateId;
  var isReply = !!privateReplyId;
  var showMarkAsSpam = isReply || contentType !== 'article' && contentType !== 'productUpdate';
  var menuItems = [{
    title: 'frontend_moderation.edit',
    type: 'normal',
    onClick: function () {
      var _onClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return onEdit(e, onEditClick, isPostTranslated, onDisplayOriginal);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onClick(_x) {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }()
  }, {
    title: 'frontend_moderation.copy_link',
    type: 'normal',
    onClick: function () {
      var _onClick2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
        var permalink;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                _context2.prev = 1;
                permalink = getPermalink(postId);
                window.location.href = permalink;
                _context2.next = 6;
                return navigator.clipboard.writeText(permalink);

              case 6:
                onShowAlert('success', 'frontend_moderation.link_copied_to_clipboard');
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                onShowAlert('error', 'frontend_moderation.failed_to_copy_link_to_clipboard');

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }));

      function onClick(_x2) {
        return _onClick2.apply(this, arguments);
      }

      return onClick;
    }(),
    href: getPermalink(postId)
  }, {
    title: 'frontend_moderation.report',
    type: 'normal',
    onClick: function onClick(e) {
      return onReport(e, showReportContentModal);
    }
  }, {
    title: 'frontend_moderation.trash',
    type: 'alert',
    onClick: function onClick(e) {
      onTrash(e, showTrashModal);
    }
  }];

  if (!isReply && isClosed !== undefined) {
    menuItems.splice(1, 0, {
      title: isClosed ? 'frontend_moderation.reopen_topic_for_replies' : 'frontend_moderation.close_topic_for_replies',
      type: 'normal',
      onClick: function () {
        var _onClick3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(e) {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0, _topicService2.onChangeCloseTopicForReplies)(e, privateId, isClosed, contentType, params.onShowAlert);

                case 2:
                  return _context3.abrupt("return", _context3.sent);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function onClick(_x3) {
          return _onClick3.apply(this, arguments);
        }

        return onClick;
      }()
    });
  }

  if (isReply) {
    menuItems.splice(1, 0, {
      title: isReplyHighlighted ? 'frontend_moderation.unmark_as_highlight' : 'frontend_moderation.mark_as_highlight',
      type: 'normal',
      onClick: function () {
        var _onClick4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  e.preventDefault();
                  _context4.next = 3;
                  return toggleHighlight(privateReplyId, isReplyHighlighted, onHighlightReply, contentType, onShowAlert);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function onClick(_x4) {
          return _onClick4.apply(this, arguments);
        }

        return onClick;
      }()
    });
  }

  if (showMarkAsSpam) {
    menuItems.splice(-1, 0, {
      title: 'frontend_moderation.mark_as_spam',
      type: 'alert',
      onClick: function onClick(e) {
        return onMarkAsSpam(e, showMarkAsSpamModal);
      }
    });
  }

  return menuItems;
};

exports.extraMenuItems = extraMenuItems;

var onEdit = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(e, onEditClick, isPostTranslated, onDisplayOriginal) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (onEditClick) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            if (!isPostTranslated) {
              _context5.next = 5;
              break;
            }

            _context5.next = 5;
            return onDisplayOriginal();

          case 5:
            e.preventDefault();
            onEditClick();

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function onEdit(_x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();

exports.onEdit = onEdit;

var onReport = function onReport(e, showReportContentModal) {
  e.preventDefault();
  showReportContentModal(true);
};

exports.onReport = onReport;

var getPermalink = function getPermalink(postId) {
  if (typeof window === 'undefined') return '';
  var topicLink = "https://".concat(window.location.hostname).concat(window.location.pathname);
  if (!postId) return topicLink;
  return "".concat(topicLink, "?postid=").concat(postId, "#post").concat(postId);
};

exports.getPermalink = getPermalink;

var onMarkAsSpam = function onMarkAsSpam(e, showMarkAsSpamModal) {
  e.preventDefault();
  showMarkAsSpamModal(true);
};

exports.onMarkAsSpam = onMarkAsSpam;

var onTrash = function onTrash(e, showTrashModal) {
  e.preventDefault();
  showTrashModal(true);
};

exports.onTrash = onTrash;

var toggleHighlight = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(replyId, isReplyHighlighted, onHighlightReply, contentType, onShowAlert) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return (0, _topicService.highlightReply)(contentType, Number(replyId), !isReplyHighlighted);

          case 3:
            onHighlightReply();
            onShowAlert('success', isReplyHighlighted ? 'frontend_moderation.reply_unhighlighted' : 'frontend_moderation.reply_highlighted');
            _context6.next = 10;
            break;

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            onShowAlert('error', isReplyHighlighted ? 'frontend_moderation.error_unhighlighting_reply' : 'frontend_moderation.error_highlighting_reply');

          case 10:
            _context6.prev = 10;
            window.location.reload();
            return _context6.finish(10);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7, 10, 13]]);
  }));

  return function toggleHighlight(_x9, _x10, _x11, _x12, _x13) {
    return _ref2.apply(this, arguments);
  };
}();

exports.toggleHighlight = toggleHighlight;